module.exports = __webpack_public_path__ + "img/1587021539.3d507f0b.jpg";